export default "__VITE_ASSET__87a67b2b__"